import {EventEmitter, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {FichePreparation} from '../models/fichePreparation';
import {BaseService} from './base.service';
import {map} from 'rxjs/operators';
import {EventModel} from '../models/event.model';
import {MoyenModel} from '../models/moyens/moyen.model';
import {DocumentModel} from '../models/fichePreparation/document.model';
import {FicheCheckResult} from '../models/fichePreparation/fiche-check-result.model';
import {handleServerResponse} from '../directives/server-response-handler';
import {FichePreparationFilter} from '../models/filtre';
import {SpringbootPage} from '../models/page.model';
import {HttpParams} from '@angular/common/http';
import {FichePreparationSearchResult} from '../models/fiche-preparation-search-result';
import {FichePreparationSearchFilter} from '../models/fiche-preparation-search-filter';
import {FichePreparationIntervention} from '../models/fiche-preparation-intervention.model';
import {FichePreparationInterventionFilter} from '../models/fiche-preparation-intervention-filter';
import {FichePreparationListResponse} from '../models/fichePreparationListResponse.model';
import {ToastReponseEnum} from '../models/enum/toast-reponse.enum';

@Injectable({providedIn: 'root'})
export class FichePreparationService extends BaseService {

  public onReloadList: EventEmitter<number> = new EventEmitter();

  getListFichePreparation(data: FichePreparationFilter): Observable<{ data: Array<FichePreparation>, nbItem: number }> {
    return this.post(environment.apiPath + 'fiche-preparation/list/false', data).pipe(
      map(item => {
        return {data: item['fichePreparations'] as Array<FichePreparation>, nbItem: item['nombreTotalFiches']};
      }),
    );
  }
  getListTypeFichePreparation(data: FichePreparationFilter): Observable<FichePreparationListResponse> {
    return this.post(environment.apiPath + 'fiche-preparation/list/true', data).pipe(
      map(item => {
        return {data: item['fichePreparations'] as Array<FichePreparation>, nbItem: item['nombreTotalFiches']};
      }),
    );
  }

  getListFichePreparationGrouped(data): Observable<FichePreparationListResponse> {
    return this.post(environment.apiPath + 'fiche-preparation/listGrouped/', data).pipe(
      map(item => {
        return {data: item['fichePreparations'] as Array<FichePreparation>, nbItem: item['nombreTotalFiches']};
      }),
    );
  }

  getFichePreparation(id): Observable<FichePreparation> {
    return this.get(environment.apiPath + 'fiche-preparation/get/' + id).pipe(
      map(item => {
        return item as FichePreparation;
      }),
    );
  }
  getFicheTypePreparation(id): Observable<FichePreparation> {
    return this.get(environment.apiPath + 'fiche-preparation/getFicheType/' + id).pipe(
      map(item => {
        return item as FichePreparation;
      }),
    );
  }

  postCheckFichePrep(data: FichePreparation): Observable<FicheCheckResult> {
    return this.post(environment.apiPath + 'fiche-preparation/check/', data).pipe(
      map(item => {
        return item as FicheCheckResult;
      }),
    );
  }

  getZipFichePrep(ids: number[], name: string): Observable<ArrayBuffer> {
    if (name === 'prepa') {
      return this.http.post(environment.apiPath + 'fiche-preparation/getMultipleFichePreparationPrint/',
        ids, {responseType: 'arraybuffer'});
    }
    if (name === 'cr') {
      return this.http.post(environment.apiPath + 'fiche-preparation/getMultipleFichePreparationPrintCR/',
        ids, {responseType: 'arraybuffer'});
    }
    if (name === 'etiquette') {
      return this.http.post(environment.apiPath + 'fiche-preparation/getMultipleFichePreparationPrintEtiquette/', ids, {responseType: 'arraybuffer'});
    }
    return null;
  }

  downloadMultiple(ids: number[], name: string): void {
    this.getZipFichePrep(ids, name).subscribe(zip => {
      const blob = new Blob([zip], {type: 'application/zip'});
      const fileName = window.URL.createObjectURL(blob);
      const downloadElement = document.createElement('a');
      downloadElement.href = fileName;
      downloadElement.setAttribute('download', 'fiches_preparation_telechargé');
      downloadElement.click();
    });
  }

  postCheckForOpFichePrep(data): Observable<boolean> {
    return this.post(environment.apiPath + 'fiche-preparation/checkForOp/', data).pipe(
      map(item => {
        return item as boolean;
      }),
    );
  }

  updateFichePreparation(fichePreparation): Observable<string> {
    return this.post(environment.apiPath + 'fiche-preparation/update/', fichePreparation).pipe(
      map(item => {
        return item as string;
      }),
    );
  }
  updateFichePreparationType(fichePreparation): Observable<String> {
    return this.post(environment.apiPath + 'fiche-preparation/updateFicheType/', fichePreparation).pipe(
      map(item => {
        return item as string;
      }),
    );
  }

  getMaxOp(num_avis, no_ot_at): Observable<number> {
    return this.get(environment.apiPath + 'fiche-preparation/getMaxOp/' + num_avis + '-' + no_ot_at).pipe(
      map(item => {
        return item as number;
      }),
    );
  }

  public deleteDocTmp(path: string): Observable<string> {
    return this.post(environment.apiPath + 'fiche-preparation/deleteTmp/' + path, path).pipe(
      map(data => {
        return data['data'] as string;
      }),
    );
  }

  updateDocument(document: DocumentModel) {
    const url = `${environment.apiPath}document`;
    return this.http.post(url, document);
  }

  rotateDocument(idDoc: number, angle: number, isType: boolean): Observable<unknown> {
    const url = `${environment.apiPath}document/rotate`;
    return this.http.post(url, {id: idDoc, angle: angle, ficheType: isType});
  }

  deleteDocument(path: string): Observable<string> {
    return this.post(environment.apiPath + 'fiche-preparation/delete/' + path, path).pipe(
      map(data => {
        return data['data'] as string;
      }),
    );
  }
  deleteDocumentType(path: string): Observable<string> {
    return this.post(environment.apiPath + 'fiche-preparation/deleteType/' + path, path).pipe(
      map(data => {
        return data['data'] as string;
      }),
    );
  }

  uploadDocument(doc: File, fiche_preparation_id, typedoc, isType: boolean): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('file', doc, doc.name);
    formData.append('fiche_preparation_id', fiche_preparation_id);
    formData.append('typedocument', typedoc);
    if (isType) {
      formData.append('isType', 'true');
    } else {
      formData.append('isType', 'false');
    }
    return this.postFile(environment.apiPath + 'fiche-preparation/import-image/', formData).pipe(
      map(data => {
        return data['data'] as string;
      }),
    );
  }

  copyDocumentType(fiche_preparation_id, fiche_type_id, typedoc, name: string): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('name', name);
    formData.append('fiche_preparation_id', fiche_preparation_id);
    formData.append('fiche_type_id', fiche_type_id);
    formData.append('typedocument', typedoc);
    return this.postFile(environment.apiPath + 'fiche-preparation/save-image-from-type/', formData).pipe(
      map(data => {
        return data['data'] as string;
      }),
    );
  }


  insertFichePreparation(usine): Observable<number> {
    return this.post(environment.apiPath + 'fiche-preparation/insert/', usine).pipe(
      map(item => {
        return item['inserted_id'];
      }),
    )
  }

  public getFiches(title, atelier): Observable<Array<FichePreparation>> {
    return this.get(environment.apiPath + 'fiche-preparation/getFiches/' + title + '/' + atelier).pipe(
      map(item => {
        return item as Array<FichePreparation>;
      }));
  }

  public getFichesCri(title, idAtelier): Observable<Array<FichePreparation>> {
    return this.get(environment.apiPath + 'fiche-preparation/fichescri/' + title + '/' + idAtelier).pipe(
      map(item => {
        return item as Array<FichePreparation>;
      }));
  }

  public getFichesCriWithMachine(machineUnique, title, idAtelier): Observable<Array<FichePreparation>> {
    return this.get(environment.apiPath + 'fiche-preparation/fichescri/' + machineUnique + '/' + title + '/' + idAtelier).pipe(
      map(item => {
        return item as Array<FichePreparation>;
      }));
  }

  public getFichesByMachine(machineUnique, title, atelier): Observable<Array<FichePreparation>> {
    return this.get(environment.apiPath + 'fiche-preparation/getFichesByMachine/' + machineUnique + '/' + title + '/' + atelier).pipe(
      map(item => {
        return item as Array<FichePreparation>;
      }));
  }

  public deleteFiche(idFiche): Observable<unknown> {
    return this.delete(environment.apiPath + 'fiche-preparation/delete/' + idFiche, ToastReponseEnum.WITH).pipe(
      map(item => {
        if (this.onReloadList != null) {
          this.onReloadList.emit(idFiche);
        }
        return item;
      }));
  }
  public deleteFicheType(idFicheType): Observable<unknown> {
    return this.delete(environment.apiPath + 'fiche-preparation/deleteFicheType/' + idFicheType, ToastReponseEnum.WITH).pipe(
      map(item => {
        if (this.onReloadList != null) {
          this.onReloadList.emit(idFicheType);
        }
        return item;
      }));
  }

  /**
   * @deprecated
   */
  public updateStatusOld(status): Observable<unknown> {
    return this.put(environment.apiPath + 'fiche-preparation/update-status/', status).pipe(
      map(item => {
        return item;
      }));
  }

  public updateDateDebut(eventFiche: EventModel): Observable<number> {
    return this.put(environment.apiPath + 'fiche-preparation/update-date-debut/', eventFiche).pipe(
      map(item => {
        return item as number;
      }));
  }

  public updateDateFin(eventFiche: EventModel): Observable<number> {
    return this.put(environment.apiPath + 'fiche-preparation/update-date-fin/', eventFiche).pipe(
      map(item => {
        return item as number;
      }));
  }

  public putReport(report): Observable<unknown> {
    return this.put(environment.apiPath + 'fiche-preparation/report/', report).pipe(
      map(item => {
        return item;
      }));
  }

  public removeRowFromMoyens(listMoyens: MoyenModel[], row) {
    listMoyens.splice(listMoyens.indexOf(row), 1);
    return listMoyens;
  }

  public updatePlanifiee(value: boolean, id: number): Observable<number> {
    return this.http.put<number>(environment.apiPathV2 + `fiche-preparation/${id}/planifiee`, value, { observe: 'response' })
      .pipe(handleServerResponse(this.toastr, {
        successMessage: 'Etat planifiee mise à jour',
        errorMessage: 'Erreur lors de la mise à jour de planifiee',
      }))
  }

  public updateVisiteChantier(value: boolean, id: number): Observable<number> {
    return this.http.put<number>(environment.apiPathV2 + `fiche-preparation/${id}/visite-chantier`, value, { observe: 'response' })
      .pipe(handleServerResponse(this.toastr, {
        successMessage: 'Visite chantier mise à jour',
        errorMessage: 'Erreur lors de la mise à jour de visite chantier',
      }))
  }

  public updateHorsPlanif(value: string | null, id: number): Observable<number> {
    return this.http.put<number>(environment.apiPathV2 + `fiche-preparation/${id}/hors-planif`, value, { observe: 'response' })
      .pipe(handleServerResponse(this.toastr, {
        successMessage: 'Valeur de la planification mise à jour',
        errorMessage: 'Erreur lors de la mise à jour de la planification',
      }))
  }

  public updateStatus(value: string, id: number): Observable<number> {
    return this.http.put<number>(environment.apiPathV2 + `fiche-preparation/${id}/status`, value, { observe: 'response' })
      .pipe(handleServerResponse(this.toastr, {
        successMessage: 'Statut mis à jour',
        errorMessage: 'Erreur lors de la mise à jour du statut',
      }))
  }

  searchFichePreparation(filter: FichePreparationSearchFilter, page: number, size: number) {
    const params = new HttpParams()
      .set('page', page)
      .set('size', size);

    return this.http.post<SpringbootPage<FichePreparationSearchResult>>(
      environment.apiPathV2 + 'fiche-preparation/search', filter, { params },
    );
  }

  getInterventionPage(filter: Partial<FichePreparationInterventionFilter>, page: number, size: number) {
    const params = new HttpParams()
      .set('page', page)
      .set('size', size);

    return this.http.post<SpringbootPage<FichePreparationIntervention>>(
      environment.apiPathV2 + 'fiche-preparation/interventions', filter, { params },
    );
  }

  getIntervention(noOtAt: string) {
    return this.http.get<FichePreparationIntervention>(
      environment.apiPathV2 + 'fiche-preparation/intervention/' + noOtAt,
    );
  }

  undoFichePreparation(id: number): Observable<FichePreparation> {
    return this.http.post<FichePreparation>(
      `${environment.apiPathV2}fiche-preparation/${id}/undo`,
      {},
    );
  }
}
